import React, { useContext } from "react";
import { useSelector } from "react-redux";
import { getRidOfDuplicateApps } from "go-app/utils";
import { ConfigContext } from "../../../../../../../services/Config/context";
import { selectOrganization } from "../../../../../../../services/organizations/selectors";
import OrganizationDashboardApplicationCard from "./OrganizationDashboardApplicationCard";

const OrganizationDashboardApplications = () => {
	const organization = useSelector(selectOrganization);
	const configService = useContext(ConfigContext);
	const applications = configService.applications();
	const uniqueApplications = getRidOfDuplicateApps(
		applications,
		organization,
		configService.getAppsOldVersionTimestamps(),
		false
	);

	return (
		<div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-4">
			{uniqueApplications.map((application) => (
				<OrganizationDashboardApplicationCard key={application.id} application={application} />
			))}
		</div>
	);
};

export default OrganizationDashboardApplications;
